import { render, staticRenderFns } from "./PdfTrainingViewer.vue?vue&type=template&id=244f7568"
import script from "./PdfTrainingViewer.vue?vue&type=script&lang=js"
export * from "./PdfTrainingViewer.vue?vue&type=script&lang=js"
import style0 from "./PdfTrainingViewer.vue?vue&type=style&index=0&id=244f7568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports